(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-items"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cart-items')) {
    class CartItems extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('quantity:change', (event) => {
          const line = event.target.closest('[data-cart-line]');
          if (line) this.updateLine(line.dataset.lineKey, event.detail.value);
        });
        this.addEventListener('click', (event) => {
          const removeButton = event.target.closest('[data-cart-remove]');
          if (removeButton) {
            const line = removeButton.closest('[data-cart-line]');
            if (line) this.updateLine(line.dataset.lineKey, 0);
          }
        });
        const note = this.querySelector('[data-cart-note]');
        if (note) {
          let noteTimer;
          note.addEventListener('input', () => {
            window.clearTimeout(noteTimer);
            noteTimer = window.setTimeout(() => this.updateNote(note.value), 500);
          });
        }

        this.addEventListener('click', (event) => {
          const addButton = event.target.closest('[data-cart-recommendation-add]');
          if (addButton) this.addRecommendation(addButton);
        });

        this.loadRecommendations();
      }

      loadRecommendations() {
        const container = this.querySelector('[data-cart-recommendations]');
        const firstLine = this.querySelector('[data-cart-line]');
        const recommendationsUrl = this.dataset.recommendationsUrl;
        if (!container || !firstLine || !recommendationsUrl) return;

        const productId = firstLine.dataset.productId;
        if (!productId) return;

        const url = `${recommendationsUrl}?product_id=${productId}&limit=4&intent=complementary&section_id=cart-recommendations`;
        fetch(url)
          .then((response) => response.text())
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const fresh = doc.querySelector('[data-cart-recommendations-content]');
            if (fresh) container.replaceChildren(...fresh.childNodes);
          })
          .catch(() => {});
      }

      addRecommendation(button) {
        const variantId = button.dataset.variantId;
        if (!variantId || button.disabled) return;
        button.disabled = true;
        this.classList.add('is-loading');
        fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{ id: variantId, quantity: 1 }],
            sections: this.getSectionIds(),
            sections_url: window.location.pathname,
          }),
        })
          .then((response) => {
            if (!response.ok) throw new Error('add failed');
            return response.json();
          })
          .then((cart) => this.renderSections(cart))
          .catch(() => {
            button.disabled = false;
            this.classList.remove('is-loading');
          });
      }

      updateNote(value) {
        fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: value }),
        });
      }

      updateLine(key, quantity) {
        this.classList.add('is-loading');
        fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: key,
            quantity,
            sections: this.getSectionIds(),
            sections_url: window.location.pathname,
          }),
        })
          .then((response) => response.json())
          .then((cart) => this.renderSections(cart))
          .catch(() => {
            this.classList.remove('is-loading');
          });
      }

      getSectionIds() {
        const ids = [this.dataset.sectionId];
        const headerSection = document.querySelector('site-header')?.closest('.shopify-section');
        if (headerSection?.id) {
          ids.push(headerSection.id.replace('shopify-section-', ''));
        } else {
          ids.push('header');
        }
        return ids;
      }

      renderSections(cart) {
        if (!cart.sections) {
          this.classList.remove('is-loading');
          return;
        }
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));

        Object.keys(cart.sections).forEach((id) => {
          const html = cart.sections[id];
          const doc = new DOMParser().parseFromString(html, 'text/html');

          document.querySelectorAll(`cart-items[data-section-id="${id}"]`).forEach((el) => {
            const fresh = doc.querySelector(`cart-items[data-section-id="${id}"]`);
            if (fresh) el.replaceWith(fresh);
          });

          const freshBubble = doc.querySelector('#cart-icon-bubble');
          if (freshBubble) {
            document.querySelectorAll('#cart-icon-bubble').forEach((el) => el.replaceWith(freshBubble.cloneNode(true)));
          }
        });
      }
    }
    customElements.define('cart-items', CartItems);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["predictive-search"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('predictive-search-dialog')) {
    class PredictiveSearchDialog extends HTMLElement {
      constructor() {
        super();
        this.dialog = this.querySelector('dialog');
        this.input = this.querySelector('[data-predictive-search-input]');
        this.results = this.querySelector('[data-predictive-search-results]');
        this.sectionUrl = this.dataset.sectionUrl;
        this.abortController = null;
        this.debounceTimer = null;

        this.querySelectorAll('[data-drawer-close]').forEach((button) => {
          button.addEventListener('click', () => this.close());
        });
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.close();
        });
        this.dialog.addEventListener('close', () => {
          document.documentElement.classList.remove('scroll-lock');
        });
        this.input.addEventListener('input', () => this.onInput());

        document.addEventListener('search:open', () => this.open());
      }

      open() {
        if (typeof this.dialog.showModal === 'function') {
          this.dialog.showModal();
        } else {
          this.dialog.setAttribute('open', '');
        }
        document.documentElement.classList.add('scroll-lock');
        window.requestAnimationFrame(() => this.input.focus());
      }

      close() {
        this.dialog.close ? this.dialog.close() : this.dialog.removeAttribute('open');
        document.documentElement.classList.remove('scroll-lock');
      }

      onInput() {
        const query = this.input.value.trim();
        window.clearTimeout(this.debounceTimer);
        if (query.length < 2) {
          this.results.innerHTML = '';
          return;
        }
        this.debounceTimer = window.setTimeout(() => this.fetchResults(query), 250);
      }

      fetchResults(query) {
        if (this.abortController) this.abortController.abort();
        this.abortController = new AbortController();

        const url = `${this.sectionUrl}?q=${encodeURIComponent(query)}&resources[type]=product,page,article&resources[limit]=6&section_id=predictive-search`;

        fetch(url, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((text) => {
            const doc = new DOMParser().parseFromString(text, 'text/html');
            const fresh = doc.querySelector('.predictive-search__results');
            this.results.innerHTML = fresh ? fresh.outerHTML : '';
          })
          .catch((error) => {
            if (error.name !== 'AbortError') this.results.innerHTML = '';
          });
      }
    }
    customElements.define('predictive-search-dialog', PredictiveSearchDialog);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-card')) {
    class ProductCard extends HTMLElement {
      constructor() {
        super();
        this.trigger = this.querySelector('[data-quick-add-trigger]');
        this.panel = this.querySelector('[data-quick-add-panel]');
        this.submit = this.querySelector('[data-quick-add-submit]');
        this.feedback = this.querySelector('[data-quick-add-feedback]');
        const json = this.querySelector('[data-product-json]');
        this.variants = json ? JSON.parse(json.textContent) : [];

        this.trigger?.addEventListener('click', () => {
          if (this.variants.length <= 1) {
            this.addToCart(this.variants[0]?.id);
          } else {
            this.panel.hidden = !this.panel.hidden;
          }
        });

        this.submit?.addEventListener('click', () => {
          const variant = this.findMatchingVariant();
          if (variant && variant.available) {
            this.addToCart(variant.id);
          } else if (variant) {
            this.setFeedback(this.feedback?.dataset.outOfStock, 'error');
          }
        });
      }

      findMatchingVariant() {
        const selected = Array.from(this.querySelectorAll('input[type="radio"]:checked')).map((input) => input.value);
        if (!selected.length) return this.variants[0];
        return this.variants.find((variant) => {
          const options = [variant.option1, variant.option2, variant.option3].filter(Boolean);
          return selected.every((value) => options.includes(value));
        });
      }

      addToCart(variantId) {
        if (!variantId) return;
        this.setFeedback('', null);
        if (this.submit) {
          this.submit.disabled = true;
          this.submit.classList.add('button--loading');
        }
        fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
        })
          .then((response) => response.json().then((data) => ({ ok: response.ok, data })))
          .then(({ ok, data }) => {
            if (!ok) throw new Error(data.description || 'error');
            this.refreshCart();
          })
          .catch(() => {
            this.setFeedback(this.feedback?.dataset.error, 'error');
          })
          .finally(() => {
            if (this.submit) {
              this.submit.disabled = false;
              this.submit.classList.remove('button--loading');
            }
          });
      }

      refreshCart() {
        fetch(`${window.Shopify?.routes?.root || '/'}cart.js`)
          .then((response) => response.json())
          .then((cart) => {
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
            document.dispatchEvent(new CustomEvent('cart-drawer:open'));
            document.querySelectorAll('cart-items').forEach((el) => {
              const sectionId = el.dataset.sectionId;
              if (!sectionId) return;
              fetch(`${window.location.pathname}?section_id=${sectionId}`)
                .then((r) => r.text())
                .then((html) => {
                  const doc = new DOMParser().parseFromString(html, 'text/html');
                  const fresh = doc.querySelector(`cart-items[data-section-id="${sectionId}"]`);
                  if (fresh) el.replaceWith(fresh);
                });
            });
          });
      }

      setFeedback(message, state) {
        if (!this.feedback) return;
        this.feedback.textContent = message || '';
        if (state) {
          this.feedback.dataset.state = state;
        } else {
          delete this.feedback.dataset.state;
        }
      }
    }
    customElements.define('product-card', ProductCard);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-form"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-form')) {
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.idInput = this.querySelector('[data-variant-id-input]');
        this.submitButton = this.querySelector('[data-add-to-cart]');
        this.submitText = this.querySelector('[data-add-to-cart-text]');
        this.spinner = this.querySelector('[data-add-to-cart-spinner]');
        this.feedback = this.querySelector('[data-form-feedback]');
        const json = this.querySelector('[data-product-variants-json]');
        this.variants = json ? JSON.parse(json.textContent) : [];
        this.sectionId = this.dataset.sectionId;
        this.productUrl = this.dataset.productUrl;

        this.addEventListener('change', (event) => {
          if (event.target.matches('input[type="radio"][data-option-position]')) {
            this.onOptionChange();
          }
          if (event.target.matches('[data-quantity-break-input]')) {
            const input = this.querySelector('[data-quantity-input]');
            if (input) input.value = event.target.dataset.quantity;
          }
        });

        if (this.form) {
          this.form.addEventListener('submit', (event) => this.onSubmit(event));
        }
      }

      getSelectedOptions() {
        return Array.from(this.querySelectorAll('input[type="radio"][data-option-position]:checked'))
          .sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition))
          .map((input) => input.value);
      }

      findMatchingVariant() {
        const selected = this.getSelectedOptions();
        if (!selected.length) return this.variants[0];
        return this.variants.find((variant) => {
          const options = [variant.option1, variant.option2, variant.option3].filter((v) => v !== null && v !== undefined);
          return selected.length === options.length && selected.every((value, index) => options[index] === value);
        });
      }

      onOptionChange() {
        const variant = this.findMatchingVariant();
        if (!variant || !this.sectionId) return;
        this.idInput.value = variant.id;

        const url = new URL(this.productUrl, window.location.origin);
        url.searchParams.set('variant', variant.id);
        url.searchParams.set('section_id', this.sectionId);

        this.classList.add('is-loading');
        fetch(url.toString())
          .then((response) => response.text())
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const freshRegion = doc.querySelector(`#${this.id} [data-product-form-region]`);
            const currentRegion = this.querySelector('[data-product-form-region]');
            if (freshRegion && currentRegion) {
              currentRegion.replaceWith(freshRegion);
            }
            const qty = this.querySelector('[data-quantity-input]');
            if (qty) qty.value = 1;
            this.updateAvailability(variant);
            history.replaceState({}, '', `${window.location.pathname}?variant=${variant.id}`);
            document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant, sectionId: this.sectionId } }));
          })
          .finally(() => this.classList.remove('is-loading'));
      }

      updateAvailability(variant) {
        const available = variant && variant.available;
        this.submitButton.disabled = !available;
        if (this.submitText) {
          this.submitText.textContent = available
            ? this.submitText.dataset.inStock || this.submitText.textContent
            : this.submitText.dataset.soldOut || this.submitText.textContent;
        }
      }

      onSubmit(event) {
        event.preventDefault();
        if (this.submitButton.disabled) return;
        this.submitButton.classList.add('button--loading');
        this.submitButton.disabled = true;
        this.spinner.hidden = false;
        this.setFeedback('', null);

        const formData = new FormData(this.form);
        fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData,
        })
          .then((response) => response.json().then((data) => ({ ok: response.ok, data })))
          .then(({ ok, data }) => {
            if (!ok) {
              this.setFeedback(data.description || this.feedback?.dataset.error, 'error');
              return;
            }
            this.setFeedback(this.feedback?.dataset.success, 'success');
            this.refreshCart();
          })
          .catch(() => this.setFeedback(this.feedback?.dataset.error, 'error'))
          .finally(() => {
            this.submitButton.classList.remove('button--loading');
            this.submitButton.disabled = false;
            this.spinner.hidden = true;
          });
      }

      refreshCart() {
        fetch(`${window.Shopify?.routes?.root || '/'}cart.js`)
          .then((response) => response.json())
          .then((cart) => {
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
            document.dispatchEvent(new CustomEvent('cart-drawer:open'));
            document.querySelectorAll('cart-items').forEach((el) => {
              const sectionId = el.dataset.sectionId;
              if (!sectionId) return;
              fetch(`${window.location.pathname}?section_id=${sectionId}`)
                .then((r) => r.text())
                .then((html) => {
                  const doc = new DOMParser().parseFromString(html, 'text/html');
                  const fresh = doc.querySelector(`cart-items[data-section-id="${sectionId}"]`);
                  if (fresh) el.replaceWith(fresh);
                });
            });
          });
      }

      setFeedback(message, state) {
        if (!this.feedback) return;
        this.feedback.textContent = message || '';
        if (state) {
          this.feedback.dataset.state = state;
        } else {
          delete this.feedback.dataset.state;
        }
      }
    }
    customElements.define('product-form', ProductForm);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-media-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-gallery')) {
    class ProductGallery extends HTMLElement {
      constructor() {
        super();
        this.slides = Array.from(this.querySelectorAll('[data-gallery-slide]'));
        this.thumbs = Array.from(this.querySelectorAll('[data-gallery-thumb]'));

        this.thumbs.forEach((thumb) => {
          thumb.addEventListener('click', () => this.setActive(thumb.dataset.mediaId));
        });

        this.querySelectorAll('[data-zoom-trigger]').forEach((trigger) => {
          trigger.addEventListener('click', () => trigger.classList.toggle('is-zoomed'));
          trigger.addEventListener('mousemove', (event) => {
            if (!trigger.classList.contains('is-zoomed')) return;
            const rect = trigger.getBoundingClientRect();
            const x = ((event.clientX - rect.left) / rect.width) * 100;
            const y = ((event.clientY - rect.top) / rect.height) * 100;
            trigger.querySelector('img').style.transformOrigin = `${x}% ${y}%`;
          });
        });

        document.addEventListener('variant:change', (event) => {
          const variant = event.detail?.variant;
          const mediaId = variant?.featured_media?.id || variant?.featured_image?.id;
          if (mediaId) this.setActive(String(mediaId));
        });
      }

      setActive(mediaId) {
        this.slides.forEach((slide) => slide.classList.toggle('is-active', slide.dataset.mediaId === String(mediaId)));
        this.thumbs.forEach((thumb) => thumb.classList.toggle('is-active', thumb.dataset.mediaId === String(mediaId)));
      }
    }
    customElements.define('product-gallery', ProductGallery);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quantity-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('quantity-selector')) {
    class QuantitySelector extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity-selector__input');
        this.min = Number(this.dataset.min || 1);
        this.max = this.dataset.max ? Number(this.dataset.max) : null;

        this.querySelector('[data-decrease]').addEventListener('click', () => this.step(-1));
        this.querySelector('[data-increase]').addEventListener('click', () => this.step(1));
        this.input.addEventListener('change', () => this.emitChange());
      }

      step(delta) {
        let value = Number(this.input.value || this.min) + delta;
        value = Math.max(this.min, value);
        if (this.max) value = Math.min(this.max, value);
        this.input.value = value;
        this.emitChange();
      }

      emitChange() {
        let value = Number(this.input.value || this.min);
        if (value < this.min) value = this.min;
        if (this.max && value > this.max) value = this.max;
        this.input.value = value;
        this.dispatchEvent(new CustomEvent('quantity:change', { bubbles: true, detail: { value } }));
      }
    }
    customElements.define('quantity-selector', QuantitySelector);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sticky-add-to-cart"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sticky-add-to-cart')) {
    class StickyAddToCart extends HTMLElement {
      constructor() {
        super();
        const targetId = this.dataset.observeTarget;
        const target = document.getElementById(targetId)?.querySelector('[data-add-to-cart]');
        if (target && 'IntersectionObserver' in window) {
          const observer = new IntersectionObserver(
            ([entry]) => {
              this.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
            },
            { threshold: 0 }
          );
          observer.observe(target);
        }

        document.addEventListener('variant:change', (event) => {
          const variant = event.detail?.variant;
          if (!variant) return;
          const priceSource = document.querySelector('[data-price-container]');
          const priceTarget = this.querySelector('[data-sticky-price]');
          if (priceSource && priceTarget) priceTarget.innerHTML = priceSource.innerHTML;

          const button = this.querySelector('.sticky-atc__button');
          if (button) button.disabled = !variant.available;
        });
      }
    }
    customElements.define('sticky-add-to-cart', StickyAddToCart);
  }
  } catch(e) { console.error(e); }
})();

})();
